/** URL/path helpers: split on first `?`, parse query without `+` → space or fragile decode errors. */

function decodeQueryComponent(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

/** Split on first `?` only (e.g. `/login?redirect=/?token=x` keeps the token inside `redirect`). */
export function splitUrlOnce(url: string): [string, string] {
  const idx = url.indexOf('?')
  if (idx === -1) return [url, '']
  return [url.slice(0, idx), url.slice(idx + 1)]
}

/** Parse `search` or `key=value&…` without turning `+` into space. */
export function parseQueryPreservingPlus(queryString: string): Record<string, string> {
  const out: Record<string, string> = {}
  const stripped = queryString.startsWith('?') ? queryString.slice(1) : queryString
  if (!stripped) return out
  for (const pair of stripped.split('&')) {
    if (!pair) continue
    const eqIdx = pair.indexOf('=')
    const rawKey = eqIdx === -1 ? pair : pair.slice(0, eqIdx)
    const rawValue = eqIdx === -1 ? '' : pair.slice(eqIdx + 1)
    out[decodeQueryComponent(rawKey)] = decodeQueryComponent(rawValue)
  }
  return out
}
